<template>
  <v-select
    @input="setUser"
    :items="enrichedUsers"
    :value="value"
    :label="label"
    item-text="selectSummary"
    item-value="id"
    :error-messages="errorMessages"
    :disable="disabled"
    return-object
  ></v-select>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'user-select',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    label: {
      type: String,
      required: false,
      default: 'Select a User'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    ...mapState('UserStore', ['user', 'users']),
    enrichedUsers () {
      return this.users
        .map(user => {
          user.selectSummary = `${user.name} <${user.email}>`
          return user
        })
    }
  },
  watch: {
    value: {
      immediate: false,
      handler (val) {
        if (val) {
          return this.$store
            .dispatch('UserStore/getUser', { id: val })
            .then(user => this.$emit('select-user', user))
            .catch(error => {
              this.$logger.error('Error loading user(s) into user-select', error.message)
              this.$flash({
                showClose: true,
                message: 'Error Loading Users(s). Reload to try again',
                type: 'error'
              })
            })
        } else {
          this.setUser({})
        }
      }
    }
  },
  mounted: function () {
    this.fetchUsers()
  },
  methods: {
    ...mapMutations('UserStore', ['saveUser']),
    setUser: function (selectedUser) {
      this.saveUser(selectedUser)
      this.$emit('input', selectedUser ? selectedUser.id : null)
      this.$emit('select-user', selectedUser)
    },
    fetchUsers: function () {
      const userFilter = {}
      return this.$store
        .dispatch('UserStore/fetchUsers', userFilter)
        .catch(error => {
          this.$logger.error('Error Fetching Users')
          this.$flash({
            showClose: true,
            message: `Error fetching Users. ${error.message}`,
            type: 'error',
            duration: 0
          })
        })
    }
  }
}
</script>
